import Header from "./Header/Header"

export default function Home() {
    return <div className="HomeMenu">
        <Header />
    </div>
}